import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      maxWidth: 880,
      width: 880,
    },
    dialogContent: {
      display: 'flex',
      flexFlow: 'column nowrap',
      paddingTop: 0,
    },
    description: {},
    dontShowAgain: {
      margin: theme.spacing(8, 0, 0, -1), // "left: -1" to account for "checkbox" padding and align left side of the checkbox with the text
    },
    buttonSubmit: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
  }),
  { name: 'TemplateFoundPopup' }
);
